var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M41,7H7c-2.7568359,0-5,2.2431641-5,5v24c0,2.7568359,2.2431641,5,5,5h34c2.7568359,0,5-2.2431641,5-5V12 C46,9.2431641,43.7568359,7,41,7z M44,36c0,1.6542969-1.3457031,3-3,3H7c-1.6542969,0-3-1.3457031-3-3V12 c0-1.6542969,1.3457031-3,3-3h34c1.6542969,0,3,1.3457031,3,3V36z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 17,
    width: 32,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 23,
    width: 32,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 29,
    width: 16,
    height: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationMedium);
export default __webpack_public_path__ + "static/media/notification--medium.03667b183c0fa504ae45bb587e9d36c1.svg";
export { ForwardRef as ReactComponent };